import { render, staticRenderFns } from "./goodsNewSetting.vue?vue&type=template&id=0cbdf88c&scoped=true&"
import script from "./goodsNewSetting.vue?vue&type=script&lang=js&"
export * from "./goodsNewSetting.vue?vue&type=script&lang=js&"
import style0 from "./goodsNewSetting.vue?vue&type=style&index=0&id=0cbdf88c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbdf88c",
  null
  
)

export default component.exports